// Bloque legal del registro: checkbox que el usuario tiene que marcar
// para aceptar política de privacidad y acuerdo de servicio. Las URLs a
// los documentos legales se construyen sobre BASE_URL (de
// fdPublicConfig).
//
// El legacy renderiza tres inputs porque KC valida tres campos
// distintos del registro custom: `accepted-legal-terms` (el visible),
// `accepted-privacy-policy` y `accepted-terms-of-service` (espejos
// invisibles para que el backend los reciba). Mantenemos el patrón.

import type { ChangeEvent } from "react";
import type { KcData } from "../kcData";
import { getFdPublicConfig } from "../window";
import { msg } from "../i18n";

export interface LegalConditionsProps {
  data: KcData;
  onChange: (key: string, value: string | boolean) => void;
}

export function LegalConditions({ data, onChange }: LegalConditionsProps) {
  const baseUrl = getFdPublicConfig().BASE_URL;
  const accepted = !!data.form?.["accepted-legal-terms"];
  const errLegal = data.messagesPerField["accepted-privacy-policy" as keyof typeof data.messagesPerField] ?? data.messagesPerField["accepted-terms-of-service" as keyof typeof data.messagesPerField];
  const errFromForm = (data.messagesPerField as Record<string, string | undefined>)["accepted-legal-terms"];
  const hasErr = !!errFromForm || !!errLegal;

  return (
    <div className="legalConditions">
      <div className={hasErr ? "has-error" : ""}>
        <label className="checkboxLegalConditions">
          <input
            type="checkbox"
            id="accepted-legal-terms"
            checked={accepted}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              onChange("accepted-legal-terms", e.target.checked);
            }}
          />
          <input
            type="checkbox"
            id="accepted-privacy-policy"
            name="accepted-privacy-policy"
            checked={accepted}
            onChange={() => undefined}
          />
          <input
            type="checkbox"
            id="accepted-terms-of-service"
            name="accepted-terms-of-service"
            checked={accepted}
            onChange={() => undefined}
          />
          <span className="customCheckbox" />
          {/* La frase tiene dos <a> inline. Se mantiene como una sola message
              con HTML; {0} y {1} se sustituyen por las URLs (base+path). */}
          <span
            className="textLegalConditions"
            dangerouslySetInnerHTML={{
              __html: msg(
                "legalConditionsAcceptHtml",
                `${baseUrl}legal/privacidad/`,
                `${baseUrl}legal/acuerdo/`,
              ),
            }}
          />
          {errFromForm ? (
            <p
              className="help-block"
              dangerouslySetInnerHTML={{ __html: errFromForm }}
            />
          ) : (
            (data.messagesPerField["accepted-privacy-policy" as keyof typeof data.messagesPerField] ||
              data.messagesPerField["accepted-terms-of-service" as keyof typeof data.messagesPerField]) ? (
              <div>
                {data.messagesPerField["accepted-privacy-policy" as keyof typeof data.messagesPerField] ? (
                  <p
                    className="help-block"
                    dangerouslySetInnerHTML={{
                      __html: data.messagesPerField["accepted-privacy-policy" as keyof typeof data.messagesPerField] as string,
                    }}
                  />
                ) : null}
                {data.messagesPerField["accepted-terms-of-service" as keyof typeof data.messagesPerField] ? (
                  <p
                    className="help-block"
                    dangerouslySetInnerHTML={{
                      __html: data.messagesPerField["accepted-terms-of-service" as keyof typeof data.messagesPerField] as string,
                    }}
                  />
                ) : null}
              </div>
            ) : null
          )}
        </label>
      </div>
    </div>
  );
}
